/*
Point5Icon.js
点五的单黑色icon
 */

import React from 'react';
import Icon from '@ant-design/icons';

const Point5SVG = ({width = '1846px', height = '2037px'}) => (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
         width={width} height={height} viewBox="0 0 1846.000000 2037.000000"
         preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,2037.000000) scale(0.100000,-0.100000)"
           fill="#000000" stroke="none">
            <path d="M4295 20358 c-124 -23 -265 -126 -322 -235 -68 -128 -63 95 -63
-2662 0 -2708 -3 -2538 54 -2655 34 -69 112 -154 177 -193 30 -18 140 -62 244
-98 1542 -540 2817 -1515 3749 -2869 60 -87 127 -176 149 -196 100 -96 255
-139 395 -110 27 6 91 33 143 61 487 258 941 417 1431 498 292 49 385 56 773
56 313 -1 382 -4 528 -23 401 -53 750 -142 1097 -279 937 -370 1712 -1028
2234 -1896 513 -853 726 -1882 596 -2887 -128 -983 -573 -1890 -1275 -2596
-1040 -1045 -2492 -1511 -3955 -1268 -602 100 -1231 349 -1740 690 -35 24 -68
40 -72 36 -4 -4 -39 -61 -79 -127 -40 -66 -122 -194 -182 -284 l-110 -165 29
-24 c503 -425 904 -936 1189 -1517 171 -350 291 -697 375 -1092 18 -84 42
-163 61 -201 56 -115 179 -216 304 -251 22 -6 126 -20 230 -31 646 -66 1321
-46 1966 60 1909 315 3609 1353 4772 2915 1106 1485 1615 3339 1426 5195 -249
2457 -1727 4648 -3929 5825 -787 421 -1698 709 -2580 814 -341 41 -437 46
-905 46 -468 0 -566 -5 -905 -46 -1054 -126 -2097 -492 -3006 -1054 l-104 -65
0 1568 c0 1715 -3 1624 58 1735 57 105 149 184 268 229 l59 23 2595 5 2595 5
53 22 c76 31 147 79 191 129 22 25 73 105 115 179 202 355 431 651 722 935
466 454 1042 798 1723 1027 l141 48 0 368 0 367 -5582 -1 c-3486 -1 -5602 -5
-5633 -11z"/>
            <path d="M1780 9379 c-744 -66 -1392 -559 -1653 -1259 -97 -259 -139 -553
-117 -820 50 -615 364 -1152 870 -1487 691 -457 1600 -422 2265 86 85 65 247
223 318 311 509 630 578 1500 175 2203 -273 478 -773 834 -1313 936 -198 38
-359 46 -545 30z"/>
            <path d="M10770 8896 c-181 -33 -354 -95 -498 -180 -388 -230 -644 -609 -711
-1053 -16 -102 -13 -332 4 -438 156 -962 1185 -1505 2065 -1089 164 78 303
178 425 305 121 126 196 235 269 389 265 561 151 1216 -289 1655 -205 206
-440 334 -735 400 -102 23 -426 29 -530 11z"/>
        </g>
    </svg>
);

const Point5Icon = (props) => (
    <Icon component={(iconProps) => <Point5SVG {...iconProps} {...props} />}/>
);

export default Point5Icon;